import { boldFont, getRelativeFontSize, mediumFont, PrimaryTextColor, regularFont } from "../../../utils/styles";

const EnquiryStyles = {
    meetingWrapper : {
        padding: "20px 20px",
    },
      showAllWrapper: {
    "& .MuiDataGrid-columnHeaderTitle":{
      ...boldFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(0),
    textTransform: "capitalize",
    },
    "& .MuiTablePagination-root":{
      ...regularFont,
      color: PrimaryTextColor,
      fontSize: getRelativeFontSize(0),

      "& .MuiTablePagination-selectLabel":{
        fontSize: getRelativeFontSize(0),
      },
      "& .MuiTablePagination-displayedRows":{
        fontSize: getRelativeFontSize(0),
      },
      
    },
    "& .MuiDataGrid-toolbarContainer":{
      ...regularFont,
      fontSize: getRelativeFontSize(0),

      "& .MuiInputBase-root":{
        ...regularFont,
        fontSize: getRelativeFontSize(0),

        "& .MuiSvgIcon-root":{
          fontSize:"1.2rem",
        },
      },
      "& .MuiButtonBase-root":{
        ...regularFont,
        fontSize: getRelativeFontSize(0),

        "& .MuiButton-startIcon":{
          marginRight:"0.313rem",
          marginLeft:"0",

          "& .MuiSvgIcon-root":{
            fontSize:"1.2rem",
          },
        },
      },
    },
  },
   menuPart:{
    display:"flex",
    alignItems:"center",
    justifyContent:"space-between",
  },

  topPart:{
    display:"flex",
    justifyContent:"end"
  },
    headerName: {
      ...boldFont,
      color: PrimaryTextColor,
      fontSize: getRelativeFontSize(-1),
      textTransform: "capitalize",
   
    },
        feildText: {
    
      color: PrimaryTextColor,
      fontSize: getRelativeFontSize(-1),

   
    },
      verticalDotButton: {
    "& button": {
      "&:hover": {
        background: "none",
      },
    },
  },
 menuItem:{
    "& .MuiTypography-root":{
      fontSize:"14px"
    }
  },
    activeBtn: {
      "& button": {
        height: "30px",
        width: "75px",
        fontSize: getRelativeFontSize(-3),
        ...mediumFont,
      },
    },
};

export default EnquiryStyles;
